import React from "react";
import { BotAvatar } from "bot-avatars";
import { cn } from "../lib/utils";

/** Decorative status illustration; people and document identities stay unchanged. */
export default function StatusAvatar({
  type = "clover",
  state = "working",
  size = 64,
  label,
  description,
  className,
}) {
  const busy = state === "working";
  return <div
    className={cn("flex flex-col items-center justify-center gap-2 text-center", className)}
    role={busy ? "status" : undefined}
    aria-live={busy ? "polite" : undefined}
  >
    <div aria-hidden="true" className="shrink-0">
      <BotAvatar type={type} state={state} size={size} face="mouth" interactive={false} jumpEvery={0} />
    </div>
    {label && <p className="text-sm font-medium text-muted-foreground">{label}</p>}
    {description && <p className="max-w-md text-sm text-muted-foreground">{description}</p>}
  </div>;
}